/** IoT Manager — microcontrollers (gateway-local). */
export const mcEndpoints = {
  list: '/v1/iot-manager/microcontrollers',
  one: (id: string) => `/v1/iot-manager/microcontrollers/${id}`,
  statuses: '/v1/iot-manager/microcontrollers/statuses',
  status: (id: string) => `/v1/iot-manager/microcontrollers/${id}/status`,
  children: (id: string) => `/v1/iot-manager/microcontrollers/${id}/children`,
  history: (id: string) => `/v1/iot-manager/microcontrollers/${id}/history`,
  historyAll: '/v1/iot-manager/microcontrollers/history',
  retire: (id: string) => `/v1/iot-manager/microcontrollers/${id}/retire`,
  assignGrowRoom: (id: string) => `/v1/iot-manager/microcontrollers/${id}/assign/grow-room`,
  assignGrowRoomRack: (id: string) => `/v1/iot-manager/microcontrollers/${id}/assign/grow-room-rack`,
  assignGrowRoomRackLevel: (id: string) =>
    `/v1/iot-manager/microcontrollers/${id}/assign/grow-room-rack-level`,
  assignPlumbingRoom: (id: string) => `/v1/iot-manager/microcontrollers/${id}/assign/plumbing-room`,
  assignPlumbingNode: (id: string) => `/v1/iot-manager/microcontrollers/${id}/assign/plumbing-node`,
  assignLocation: (id: string) => `/v1/iot-manager/microcontrollers/${id}/assign/location`,
  unassign: (id: string) => `/v1/iot-manager/microcontrollers/${id}/assignment`,
} as const;
